import { computed } from 'vue';
import { SiteRouteNames } from '~/types/types';
import type { NuxtLinkProps } from 'nuxt/app';

export type IpaMenuItem = {
  label: string;
  title?: string;
  to?: NuxtLinkProps['to'];
  shouldRender: boolean;
};

/**
 * IPA (Company) Navigation
 * For public-facing corporate site pages
 */
export const useIpaNavigation = () => {
  const menuItems = computed<IpaMenuItem[]>(() => [
    {
      label: 'About',
      to: { name: SiteRouteNames.about },
      shouldRender: true,
    },
    {
      label: 'Our Work',
      to: { name: SiteRouteNames.work },
      shouldRender: true,
    },
    {
      label: 'Contact',
      to: { name: SiteRouteNames.contact },
      shouldRender: true,
    },
  ]);

  const visibleItems = computed(() => {
    return menuItems.value.filter((item) => item.shouldRender);
  });

  return {
    menuItems,
    visibleItems,
  };
};
